/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ApplicationAnswerFieldValueSource } from './applicationAnswerFieldValueSource';

/**
 * One field entry for PATCH application-answers (#20).
 */
export interface ApplicationAnswerFieldValue {
  value?: unknown | null;
  blank?: boolean;
  source?: ApplicationAnswerFieldValueSource;
}
